import React from "react";
import PropTypes from "prop-types";
import { useLocation, useNavigate } from "react-router-dom";
import { companyRoutes, companyProducts } from "./navbar";
import { eventsUrl } from "../../constant";

const NavDrawer = ({ onClose, open, logo }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleMenuClick = (path) => {
    if (pathname !== path) {
      navigate(path);
      onClose();
    }
  };

  return (
    <div
      className={`xs:hidden flex flex-col items-center justify-center overflow-hidden p-8 gap-5 absolute ${
        open ? "top-0" : "top-[-100%]"
      } left-0 right-0 transition-all duration-500 bg-gray-100 shadow-2xl z-50`}
      onClick={onClose}
    >
      <div>
        <img src={logo} alt="Asapuu" className="w-28" />
      </div>
      <div>
        <div className="mb-7">
          <h3 className="font-mabry-bold text-lg">Products</h3>
          <ul className="flex flex-col gap-2">
            {companyProducts.map((item) => (
              <li
                key={item.key}
                onClick={() => handleMenuClick(item.path)}
                className="cursor-pointer"
              >
                {item.label}
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="font-mabry-bold text-lg">Company</h3>
          <ul className="flex flex-col gap-2">
            {companyRoutes.map((item) => (
              <li
                key={item.path}
                onClick={() => handleMenuClick(item.path)}
                className="cursor-pointer"
              >
                {item.label}
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-7">
          <a
            href={eventsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 font-mabry-bold text-lg"
          >
            Events

            <span className="text-[10px] uppercase bg-primary text-white rounded-full px-2 py-0.5 leading-none">
              New
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

NavDrawer.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  logo: PropTypes.string.isRequired,
};

export default NavDrawer;
